import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { SUBMETRIC_ROW_WIDTHS } from '../helper';
import { GeneralMetricType } from '../types';
import {
  Feature,
  isFeatureEnabled,
} from '../../../../../config/FeaturesConfig';
import { getEnvConfigByKey } from '../../../../../config/EnvConfig';

interface DisplaySubMetricsHeaderProps {
  type: string;
  submetric?: GeneralMetricType;
  customRowWidths?: string[];
}

const DisplaySubMetricsHeader: React.FC<DisplaySubMetricsHeaderProps> = ({
  type,
  submetric,
  customRowWidths,
}: DisplaySubMetricsHeaderProps): React.ReactElement => {
  const submetrics = submetric?.submetrics;
  const legacyExperience = !isFeatureEnabled(Feature.LIGHTHOUSE);
  const isTM = getEnvConfigByKey('isTm') === 'true';

  const submetricsCheck = (submetrics: any) => {
    if (submetrics) {
      for (const [key, value] of Object.entries(submetrics)) {
        if (key === '__typename') return false;
        if (value !== null) return true;
      }
      return false;
    }
    return false;
  };

  return submetricsCheck(submetrics) ? (
    <Row
      alignmentHorizontal='start'
      widths={
        customRowWidths === undefined || customRowWidths === null
          ? SUBMETRIC_ROW_WIDTHS
          : customRowWidths
      }
      spacingInset='none'
      spacing='none'
    >
      <Column>
        <Text type='b200'>
          <b>
            <FormattedMessage
              id='cs_perfportal_subMetric'
              defaultMessage='Sub Metrics'
            />
          </b>
        </Text>
      </Column>
      <Column>
        <Text type='b200'>
          <b>
            {isTM ? (
              <FormattedMessage
                id='cs_perfportal_my_team'
                defaultMessage='My Team'
              />
            ) : (
              <FormattedMessage
                id='cs_perfportal_my_result'
                defaultMessage='My Result'
              />
            )}
          </b>
        </Text>
      </Column>
      {!legacyExperience && (
        <Column>
          <Text type='b200'>
            <b>
              <FormattedMessage
                id='cs_perfportal_network_benchmark'
                defaultMessage='Network Benchmark'
              />
            </b>
          </Text>
        </Column>
      )}
    </Row>
  ) : (
    <></>
  );
};

export default DisplaySubMetricsHeader;
